import React from "react";

export type InsightsPeriod = "weekly" | "fortnightly" | "monthly";

interface PeriodSelectorProps {
  period: InsightsPeriod;
  onChange: (p: InsightsPeriod) => void;
}

const OPTIONS: { key: InsightsPeriod; label: string }[] = [
  { key: "weekly", label: "Weekly" },
 { key: "fortnightly", label: "Fortnightly" },
 { key: "monthly", label: "Monthly" },
];

const PeriodSelector: React.FC<PeriodSelectorProps> = ({ period, onChange }) => {
  return (
    <div className="flex items-center gap-2">
      {OPTIONS.map((o) => {
        const active = o.key === period;
        return (
          <button
            key={o.key}
            onClick={() => onChange(o.key)}
            className={`px-4 py-1.5 rounded-full text-[13px] font-inter transition-colors border ${
              active
                ? "bg-[#1F1F1F] text-white border-[#1F1F1F] font-semibold"
                : "bg-white text-[#1F1F1F] border-[#E5E7EB] font-medium hover:bg-gray-50"
            }`}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
};

export default PeriodSelector;
